import React, {useCallback, useEffect, useRef, useState} from 'react';
import {styles} from './styles';

import {
  Image,
  Pressable,
  View,
  TouchableOpacity,
  Linking,
  Platform,
} from 'react-native';
import CCText from '@/Atoms/CCText';
import Icon from 'react-native-vector-icons/FontAwesome5';
import Feather from 'react-native-vector-icons/Feather';
import {StyleSheet, ViewStyle} from 'react-native';
import {Colors} from '@/styles';
import {
  CommonActions,
  DrawerActions,
  useNavigation,
} from '@react-navigation/native';
import Ionicons from 'react-native-vector-icons/Ionicons';
import {
  getLocalStorage,
  getRouteMap,
  handleLogout,
  removeLocalStorage,
  setLocalStorage,
} from '@/Utils/CommonUtils';
import { lastMessagePreview, stripHtmlForPreview } from '@/Utils/inboxMessagePreview';
import Entypo from 'react-native-vector-icons/Entypo';
import {useUserPlanStore, selectIsCsocUser} from '@/Store/userPlanStore';

import Animated, {
  useSharedValue,
  useAnimatedStyle,
  interpolateColor,
  interpolate,
  withTiming,
  Easing,
  withDelay,
  withRepeat,
  withSequence,
} from 'react-native-reanimated';

import CCColors, {updateColorWithOpacity} from '@/Utils/CCColors';
import useLoggedInUserStore from '@/Store/loggedInUserstore';
import {useShallow} from 'zustand/react/shallow';
import OnboardingRing from '@/Components/OnboardingRing';
import useOnboardingSheetStore from '@/Store/onboardingSheetStore';
import {
  useOnboardingComplete,
  useOnboardingPercent,
} from '@/Store/onboardingProgressStore';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import CCButton from '../CCButton';
import FunChallengeInProgressPill from '@/Components/FunChallengeInProgressPill';
import useAnimation from '@/Hooks/useAnimation';
import {ScreenName} from '@/navigators/StackConstants';
import ENV from '../../../environment';
import useGetExpiryStatus from '@/Hooks/RenewalApi/useGetExpiryStatus';
import useSound from 'use-sound';

import notificationSoundMp3 from '../../Assets/Sounds/notification.mp3';
import successSound from '../../Assets/Sounds/success.mp3';
import wrongSound from '../../Assets/Sounds/wrong.mp3';
import levelupSound from '../../Assets/Sounds/levelup.mp3';
import ConditionalRender from '../ConditionalRender';
import Box from '../Box';
import GamePlayClient from '@/Api/GameClient';
// import ChallengeComponent from '@/Components/ChallengeComponent';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';
import Streak from './Components/Streak';
import PingIndicator from '@/Components/PingIndicator';
import SlideModal from '../SlideModal';
import {PopUp} from '@/Screens/Visualisation/components/LevelModal';
import Spacer from '../Spacer';
import {FontSizes, SCREEN_WIDTH, vs} from '@/Utils/Dimensions';
import {useSocket} from '@/Hooks/UseSocket';
import UserAssistance from '@/Components/UserAssistance';
import NotificationModal from './Components/NotificationModal';
import {useNotificationStore} from '@/Store/useNotificationStore';
import {MaterialCommunityIcons} from '@expo/vector-icons';
import UserAccessDropdown from './Components/Dropdown';
import useGetUserAccessApi from '@/Hooks/UserAccessApi/useUserAccessApi';
import SupportModal from '@/Components/UserAssistance/component/SupportModal';
import {RFPercentage} from 'react-native-responsive-fontsize';
import {useUserAccessStore} from '@/Hooks/UserAccessApi/store/useUserAccessStore';
import SwitchToAppBanner from './SwitchToAppBanner';
import useGamePlayState from '@/Store/GamePlayStore';
import Foundation from 'react-native-vector-icons/Foundation';
import {RAISE_A_TICKET} from '@/Utils/Constants';
import {useToast} from '@/toast/useToast';
import {shallow} from 'zustand/shallow';
import MeetingsBanner from '@/Screens/Books/components/MeetingsBanner';
import {LinearGradient} from 'expo-linear-gradient';
import {ICON_MAP} from '@/Screens/Books/components/Meetings';
import {useHeaderExtensionStore} from '@/Store/useHeaderExtensionStore';
// const schema = require('/Users/whynew/Circlechess/cc-client-sdk/lib/schema.js');

// const schema = '';
// const schema = require('/home/sk/sources/cc-client-sdk/lib/schema.js');
// const schema = require('/home/administrator/Desktop/SDK client/cc-client-sdk/lib/schema.js');
// const schema = '';
// const schema = require('/home/sk/sources/cc-client-sdk/lib/schema.js');

function menu(
  triggerComponent,
  navigate,
  onLoginStateChange,
  data,
  summaryData,
  setModifyMainMenu,
  userRelationData,
  modifyMainMenu,
  setHeaderName,
  isMobileOrTab,
  handleSwitchToProfile,
  userAccess,
) {
  const onboardingComplete = useOnboardingComplete();
  const onboardingPercent = useOnboardingPercent();
  const [showPopup, setShowPopup] = useState(false);
  const [showDeletePopup, setDeleteShowPopup] = useState(false);
  const [open, setOpen] = React.useState<boolean>(false);
  const [dropdown, setDropdown] = React.useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [modifyDropdown, setModifyDropdown] = React.useState<boolean>(false);
  const [dropdownPosition, setDropdownPosition] = useState({top: 0, left: 0});
  const [openModal, setOpenModal] = useState(false);
  const userAccessRef = useRef(null);
  // const notifications = useNotificationStore(state => state.notifications);
  const navigation = useNavigation();
  const removeNotification = useNotificationStore(
    state => state.removeNotification,
  );

  const [openNotificationsModal, setOpenNotificationsModal] =
    React.useState(false);
  const notifications = useNotificationStore(state => state.notifications);

  const hasNewNotifications = useNotificationStore(state =>
    state.hasNewNotifications(),
  );
  const hasNewInboxMessages = useNotificationStore(state =>
    state.hasNewInboxMessages(),
  );
  const hasNewUserRaisedIssue = useNotificationStore(state =>
    state.hasNewUserRaisedIssue(),
  );
  const handleDeleteNotification = (id: string) => {
    removeNotification(id);
    // setNotifications(prev => prev.filter(notif => notif.id !== id));
  };
  const markAllAsRead = useNotificationStore(state => state.markAllAsRead);
  function handleOnCancel() {
    setShowPopup(false);
    setDeleteShowPopup(false);
  }

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleOpen = () => {
    setOpenModal(true);
  };
  const state = navigation.getState();
  const currentRoute = state?.routes?.[0]?.name ?? null;
  const planDetails = useUserPlanStore(s => s.planDetails);
  // User access (linked-account switching) applies to School-of-Chess
  // accounts AND coaches — a coach's own login often has no CSOC
  // subscription, but cc_csoc_coach marks it (summary user.is_coach).
  const isCoachAccount = useLoggedInUserStore(s => !!s.userData?.is_coach);
  const isCsocUser = selectIsCsocUser(planDetails) || isCoachAccount;
  const items = [
    {
      key: 'Notifications',
      title: 'Notifications',
      icon: 'bell',
      onPress: () => {
        setOpenNotificationsModal(true);
        markAllAsRead();
        // navigate(ScreenName.Settings);
      },
    },
    {
      key: 'account',
      title: 'My Profile',
      icon: 'user',
      onPress: () => {
        // Falls back to Settings when the Player Profile feature isn't
        // enabled for this build -- the screen isn't even registered when
        // ENV.PLAYER_PROFILE_ENABLED is off, so navigating there would be a
        // silent no-op.
        if (!ENV.PLAYER_PROFILE_ENABLED) {
          if (window.location.pathname.toLowerCase().includes('/classroom')) {
            window.open(`${window.location.origin}/${ScreenName.Settings}`, '_blank');
            return;
          }
          navigate(ScreenName.Settings);
          return;
        }
        if (window.location.pathname.toLowerCase().includes('/classroom')) {
          // PlayerProfile's registered path is `profile/:username?` (see
          // playerProfileLinking.ts), not its screen name -- unlike
          // Settings, a raw `/PlayerProfile` URL wouldn't resolve. No
          // username needed either: the screen falls back to "me" when
          // opened without one (same as Settings' own "View my public
          // profile" link).
          window.open(`${window.location.origin}/profile`, '_blank');
          return;
        }
        navigate(ScreenName.PlayerProfile);
      },
    },
    // "User access" (switching between linked accounts) only applies to
    // Active School-of-Chess users.
    ...(isCsocUser
      ? [
          {
            key: 'User access',
            title: 'User access',
            icon: 'user-circle',
            onPress: () => {},
          },
        ]
      : []),
    {
      key: 'Support Tickets ',
      title: RAISE_A_TICKET,
      icon: 'exclamation-triangle',
      onPress: () => {
        if (currentRoute === ScreenName.SupportTicket) {
          navigation.dispatch(
            CommonActions.reset({
              index: 0,
              routes: [{name: ScreenName?.SupportTicket}],
            }),
          );
        } else {
          if (window.location.pathname.toLowerCase().includes('/classroom')) {
            const url = `${window.location.origin}/${ScreenName.SupportTicket}`;
            window.open(url, '_blank');
            return;
          } else {
            navigate(ScreenName.SupportTicket);
          }
        }
      },
    },
    {
      key: 'Inbox',
      title: 'Inbox',
      icon: 'envelope',
      onPress: () => {
        if (window.location.pathname.toLowerCase().includes('/classroom')) {
          const url = `${window.location.origin}/${ScreenName.Inbox}`;
          window.open(url, '_blank');
          return;
        }
        navigate(ScreenName.Inbox);
      },
    },
    {
      key: 'logout',
      title: 'Logout',
      icon: 'sign-out-alt',
      onPress: () => {
        setShowPopup(true);
      },
    },
  ];
  if (!onboardingComplete) {
    items.unshift({
      key: 'Finish setup',
      title: `Finish setup — ${onboardingPercent}%`,
      icon: 'tasks',
      onPress: () => useOnboardingSheetStore.getState().openSheet('dropdown'),
    });
  }
  const coachItems = [
    {
      key: 'Switch to my Profile',
      title: 'Switch to my Profile',
      icon: 'user',
      onPress: () => handleSwitchToProfile(),
    },
    {
      key: 'User access',
      title: 'User access',
      icon: 'user-circle',
      onPress: () => {},
    },
  ];
  // Derived every render (no useState copy): a state snapshot only re-synced
  // on modifyMainMenu changes went stale when the CSOC flag or onboarding
  // percent resolved after first paint, freezing the User-access gating.
  const menuItems = modifyMainMenu ? coachItems : items;
  const handleOpenDropdown = item => {
    if (userAccessRef.current) {
      userAccessRef.current.measure((fx, fy, width, height, px, py) => {
        setDropdownPosition({
          top: py, // Align vertically with the button
          left: px - 150, // Move left (adjust value as needed)
        });
      });
    }
    setSelectedItem(item);
    setDropdown(!dropdown);
  };

  // Computed once so the divider below (last item = no border) can key off
  // its length instead of the outer `items` — `items` no longer matches
  // 1:1 with what's rendered now that "User access" is conditional.
  const visibleMenuItems = menuItems.filter(
    item =>
      !(
        isMobileOrTab &&
        (item.title === 'User access' || item.title === 'Switch to my Profile')
      ),
  );

  return (
    <>
      {showPopup && (
        <SlideModal
          visible={showPopup}
          type="center"
          customStyle={styles.levelModalCustom}>
          <PopUp
            confirm={async () => {
              await handleLogout();
              onLoginStateChange();
            }}
            cancel={handleOnCancel}
            text={'Are you sure you want to logout?'}
            buttonConfirm="Logout"
          />
        </SlideModal>
      )}
      <NotificationModal
        open={openNotificationsModal}
        handleClose={() => setOpenNotificationsModal(false)}
        notifications={notifications}
        onDeleteNotification={handleDeleteNotification}
      />

      <DropdownMenu.Root
        open={open}
        onOpenChange={isOpen => {
          setOpen(isOpen);
          if (!isOpen) {
            setDropdown(false);
          }
        }}>
        <DropdownMenu.Trigger style={{outlineStyle: 'none'}} asChild>
          {triggerComponent}
        </DropdownMenu.Trigger>

        <DropdownMenu.Portal>
          <DropdownMenu.Content>
            {dropdown && selectedItem && (
              <View
                style={{
                  position: 'absolute',
                  top: dropdownPosition.top,
                  left: dropdownPosition.left,
                  backgroundColor: 'white',
                  elevation: 5,
                  zIndex: 1000,
                }}>
                <UserAccessDropdown
                  dropdownData={userRelationData}
                  dropdown={dropdown}
                  item={selectedItem}
                  summaryData={summaryData}
                  setModifyMainMenu={setModifyMainMenu}
                  setDropdown={setDropdown}
                  setOpen={setOpen}
                  setHeaderName={setHeaderName}
                  userAccess={userAccess}
                />
              </View>
            )}
            <View style={styles.userMenu}>
              {visibleMenuItems.map((item, index) => (
                <DropdownMenu.Item key={item.key} asChild>
                  <View
                    ref={item?.title === 'User access' ? userAccessRef : null}>
                    <CCButton
                      onPress={() => {
                        item.onPress();
                        if (item?.title === 'User access') {
                          handleOpenDropdown(item);
                        } else {
                          setOpen(false);
                          setDropdown(false);
                        }
                      }}
                      style={styles.userMenuItem}
                      contentContainerStyle={styles.userMenuItemContent}>
                      <View
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                        }}>
                        <Box
                          flexDirection="column"
                          style={{
                            borderBottomWidth:
                              index === visibleMenuItems.length - 1
                                ? 0
                                : StyleSheet.hairlineWidth,
                            borderColor: CCColors.Grey.Border,
                            paddingVertical: 8,
                          }}>
                          <Box
                            flexDirection="row"
                            style={{
                              width: 210,
                            }}
                            justifyContent="space-between">
                            <Box flexDirection="row">
                              {item?.title === 'Logout' ? (
                                <MaterialCommunityIcons
                                  name="logout"
                                  account-supervisor-outline
                                  size={16}
                                  style={styles.userMenuItemIcon}
                                />
                              ) : item?.title === 'Switch to my Profile' ? (
                                <MaterialCommunityIcons
                                  name="account-supervisor-outline"
                                  size={24}
                                  style={{
                                    color: CCColors.TextColor.Dark,
                                    marginRight: 2,
                                    lineHeight: 18,
                                  }}
                                />
                              ) : item?.title === RAISE_A_TICKET ? (
                                <MaterialCommunityIcons
                                  name="message-question-outline"
                                  size={18}
                                  style={{
                                    color: CCColors.TextColor.Dark,
                                    marginRight: 4,
                                    lineHeight: 18,
                                  }}
                                />
                              ) : (
                                <Icon
                                  style={styles.userMenuItemIcon}
                                  name={item.icon}
                                  size={16}
                                  color={Colors.primaryDark}
                                />
                              )}
                              <CCText style={styles.userMenuItemText}>
                                {item.title}
                              </CCText>
                            </Box>

                            {item?.title === 'User access' && (
                              <Box
                                style={{
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}>
                                <MaterialCommunityIcons
                                  name={
                                    dropdown ? 'chevron-up' : 'chevron-down'
                                  }
                                  color={CCColors.Black}
                                  size={14}
                                  style={{
                                    fontWeight: 'bold',
                                  }}
                                />
                              </Box>
                            )}
                          </Box>
                        </Box>

                        {item?.title === 'Notifications' &&
                          hasNewNotifications && (
                            <View
                              style={{
                                width: 6,
                                height: 6,
                                borderRadius: 25,
                                backgroundColor: CCColors.Red,
                                position: 'absolute',
                                top: -1,
                                left: 9,
                              }}
                            />
                          )}
                        {item?.title === 'Inbox' &&
                          hasNewInboxMessages != 0 && (
                            <View
                              style={{
                                width: 10,
                                height: 10,
                                borderRadius: 25,
                                backgroundColor: CCColors.Red,
                                position: 'absolute',
                                top: 1,
                                left: 9,
                              }}
                            />
                          )}
                        {item?.title === RAISE_A_TICKET &&
                          hasNewUserRaisedIssue != 0 && (
                            <View
                              style={{
                                width: 10,
                                height: 10,
                                borderRadius: 25,
                                backgroundColor: CCColors.Red,
                                position: 'absolute',
                                top: 1,
                                left: 9,
                              }}
                            />
                          )}
                      </View>
                    </CCButton>
                  </View>
                </DropdownMenu.Item>
              ))}
            </View>
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </DropdownMenu.Root>
      <SupportModal openModal={openModal} handleClose={handleClose} />
    </>
  );
}

export function useAnimatedColor({
  start = 'rgba(255, 255, 255, 0)',
  end,
  duration = 200,
}) {
  const sv = useSharedValue(0);
  const style = useAnimatedStyle(() => {
    return {
      backgroundColor: interpolateColor(sv.value, [0, 1], [start, end]),
    };
  });

  const [isFocused, setIsFocused] = useState<boolean>(false);

  const setAnimationValue = value => {
    setIsFocused(isFocused => {
      if (!isFocused) {
        // console.log('zzz', sv.value);
        sv.value = withTiming(value, {duration: duration});
      }
      return isFocused;
    });
  };

  function setFocused(isFocused) {
    setIsFocused(isFocused);
  }

  return [style, setAnimationValue, setFocused];
}

export default function Header({
  userData,
  avatar,
  isMobile,
  navigationRef,
  onLoginStateChange,
  route,
  summaryData,
  setModifyMainMenu,
  modifyMainMenu,
  isEvaluateUser,
  showAppModal,
  setShowAppModal,
}) {
  const navigation = useNavigation();
  const onboardingComplete = useOnboardingComplete();
  const onboardingPercent = useOnboardingPercent();
  const lastScore = useRef();
  const [headerName, setHeaderName] = useState('');
  const userPlanStore = useUserPlanStore();
  // Header "Raise a Ticket" CTA: kept for School-of-Chess users and coaches
  // (cc_csoc_coach -> summary user.is_coach); everyone else uses the profile
  // dropdown's Raise a Ticket entry.
  const showRaiseTicketCta =
    selectIsCsocUser(userPlanStore?.planDetails) || !!userData?.is_coach;
  const [openModal, setOpenModal] = useState(false);
  const handleClose = () => {
    setOpenModal(false);
  };
  const {data: expiryStatus} = useGetExpiryStatus();
  const [iconDetails, setIconDetails] = useState({});
  const [screenName, setScreenName] = useState<string>('Dashboard');
  const [showMyComponent, setShowMyComponent] = useState(false);
  const [accessToken, setAccessToken] = useState('');
  const [userRelationData, setUserRelationData] = useState({});
  const socket = useSocket();
  const gamePlayStore = useGamePlayState();
  const shimmerProgress = useSharedValue(0);
  const headerExtension = useHeaderExtensionStore(
    state => state.headerExtension,
  );
  const wsOverrideActive = useHeaderExtensionStore(
    state => state.wsOverrideActive,
  );

  // WebSocket event is the master switch when received:
  // - wsOverrideActive=false (no WS event yet) → use API data
  // - wsOverrideActive=true + headerExtension has data → use WS data
  // - wsOverrideActive=true + headerExtension is null → hide banner
  const activeStatusMessage = wsOverrideActive
    ? headerExtension
    : summaryData?.status_message;

  const setAuthorizationToken = async () => {
    const token = await getLocalStorage('access_token');
    if (token) {
      setAccessToken(`Bearer ${token}`);
    }
  };
  const handleEvaluateUrl = async () => {
    const url = await Linking.getInitialURL();
    if (url?.includes('/evaluateLogin?tournamentId=') && !isEvaluateUser) {
      const queryString = url.split('?')[1];
      const params = {};

      if (queryString) {
        queryString.split('&').forEach(pair => {
          const [key, value] = pair.split('=');
          params[key] = decodeURIComponent(value);
        });
      }

      const tournamentId = params['tournamentId'];

      await handleLogout(() => {
        window.location.href = `/evaluateLogin?tournamentId=${tournamentId}`;
      });
    }
  };
  useEffect(() => {
    shimmerProgress.value = withRepeat(
      withSequence(
        withTiming(1, {
          duration: 5000,
          easing: Easing.ease,
        }),
        withTiming(0, {duration: 0}), // Instant reset, no pause
      ),
      5,
      false,
    );
  }, []);
  const shimmerStyle = useAnimatedStyle(() => {
    const translateX = interpolate(
      shimmerProgress.value,
      [0, 1],
      [-SCREEN_WIDTH, SCREEN_WIDTH], // Adjust based on your component width
    );

    return {
      transform: [{translateX}],
    };
  });

  useEffect(() => {
    if (!isEvaluateUser) {
      handleEvaluateUrl();
    }
  }, [isEvaluateUser]);

  const handleUserAccessSuccess = data => {
    setUserRelationData(data?.user_access);
    useUserAccessStore.getState().setUserAccess(data?.user_access);
  };
  const handleUserAccessError = () => {};
  const {
    mutate: userAccess,
    data: userAccessData,
    isLoading,
  } = useGetUserAccessApi(handleUserAccessSuccess, handleUserAccessError);
  const [client, setClient] = useState(null);
  const [duplicateTabHeaderName, setDuplicateTabHeaderName] = useState('');
  const {isMobileOrTab} = useMediaQuery();

  // const CCApplicationClient = () => {
  //   console.log('User Data = ', userData);
  //   if (userData.user_id) {
  //     console.log(
  //       'Async .. Logging in with username: ',
  //       userData.user_id,
  //       accessToken,
  //     );

  //     const cc_client: any = socket;
  //     // if (cc_client) {
  //     //   if (challengeRequestCallback) {
  //     //     console.log('Inside challenge Request Check .. ');
  //     //     cc_client.registerMessageType(
  //     //       'challenge_request_check',
  //     //       schema.challengeGameMsgSchema,
  //     //       function (socket, data) {
  //     //         console.log('Inside challenge_request_check .... ');
  //     //         challengeRequestCallback(socket, data);
  //     //       },
  //     //     );
  //     //   }

  //     //   if (challengeRejectedCallback) {
  //     //     cc_client.registerMessageType(
  //     //       'challenge_reject',
  //     //       schema.challengeGameMsgSchema,
  //     //       function (socket, data) {
  //     //         challengeRejectedCallback(socket, data);
  //     //       },
  //     //     );
  //     //   }

  //     //   if (challengeExpiredCallback) {
  //     //     cc_client.registerMessageType(
  //     //       'challenge_request_expire',
  //     //       schema.challengeGameMsgSchema,
  //     //       function (socket, data) {
  //     //         challengeExpiredCallback(socket, data);
  //     //       },
  //     //     );
  //     //   }

  //     //   if (challengeCancelCallback) {
  //     //     cc_client.registerMessageType(
  //     //       'challenge_cancel',
  //     //       schema.challengeGameMsgSchema,
  //     //       function (socket, data) {
  //     //         challengeCancelCallback(socket, data);
  //     //       },
  //     //     );
  //     //   }

  //     //   if (registerChallengeRequest) {
  //     //     cc_client.registerMessageType(
  //     //       'challenge_game_request',
  //     //       schema.challengeGameMsgSchema,
  //     //       function (socket, data) {
  //     //         console.log('About to call challenge response message handler ... ');
  //     //         registerChallengeRequest(socket, data);
  //     //       },
  //     //     );
  //     //   }
  //     // }
  //     setClient(cc_client);

  //     function challengeResponseMessageHandler(socket, data) {
  //       console.log('...challenge_cancel message data...', data);
  //       setShowChallengeCancel(true);
  //       setShowChallengeRequest(false);
  //     }

  //     function challengeCancelCallback(socket, data) {
  //       console.log('Challenge Cancel Callback ... ', data, cc_client);
  //       if (cc_client || client) {
  //         cc_client.username = userData?.user_id;
  //         setShowChallengeCancel(true);
  //         setShowChallengeRequest(false);
  //       }
  //     }

  //     function challengeRequestCallback(socket, data) {
  //       console.log('Challenge Request Callback v2 ... ', data, cc_client);
  //       if (!cc_client && !client) {
  //         return;
  //       }
  //       console.log(
  //         '...challenge_request_check message data... v Header',
  //         data.userId,
  //         userData.user_id,
  //         userData.user_id === data.userId,
  //       );
  //       console.log('User Data = ', userData);
  //       if (
  //         data.userId == userData.user_id ||
  //         data.userId + '' === userData.user_id + ''
  //       ) {
  //         setShowChallengeRequest(true);
  //         setChallengeOpponent(data.opponent);
  //         setChallengeVariantId(data.variantId);
  //         setChallengeMoveTimer(data.playerMoveTimer);
  //         setChallengeIncrement(data.moveTimeIncrement);
  //         setChallengePosition(data.gameState);
  //         setGamePlayMode(data.gamePlayMode);
  //         setChallengeWhite(data.white);
  //       }
  //     }

  //     function challengeRejectedCallback(socket, data) {
  //       console.log('Challenge Reject Callback ... ', data, cc_client);
  //       if (!cc_client && !client) {
  //         return;
  //       }
  //       console.log('...challenge_reject message data...', data);
  //       setShowChallengeReject(true);
  //     }

  //     function challengeExpiredCallback(socket, data) {
  //       console.log('Challenge Expired Callback ... ', data, cc_client);
  //       if (!cc_client && !client) {
  //         return;
  //       }
  //       console.log('...challenge_reject message data...', data);
  //       setShowChallengeExpire(true);
  //       setShowChallengeRequest(false);
  //     }

  //     function registerChallengeRequest(socket, data) {
  //       console.log(
  //         '... Registering Challenge Request from within Header ...',
  //         data,
  //       );
  //       setShowChallengeCancel(true);
  //       setShowChallengeRequest(false);
  //     }
  //   }
  // };

  // useEffect(() => {
  //   console.log('Changed Screen name - ', screenName);
  //   if (userData.user_id && accessToken && screenName !== ScreenName.PlayChess && socket)
  //     CCApplicationClient();
  // }, [screenName, accessToken, socket]);

  // useEffect(() => {
  //   if (!accessToken) {
  //     setAuthorizationToken();
  //   }
  //   if (userData.user_id && accessToken && screenName !== ScreenName.PlayChess)
  //     CCApplicationClient();
  // }, [accessToken]);

  const [isUserMenuOpen, setIsUserMenuOpen] = useState<boolean>(false);
  function toggleHamburger() {
    navigationRef.current.dispatch(DrawerActions.openDrawer());
  }

  function navigate(args) {
    navigationRef.navigate(args);
  }

  const [gemsAnimValue, setGemsAnimValue] = useAnimation({
    prop: 'backgroundColor',
    start: 'rgba(255, 255, 255, 0)',
    end: CCColors.Green,
    isColor: true,
  });
  useEffect(() => {
    const previous = lastScore.current;
    const next = userData?.net_score;
    lastScore.current = next;
    if (typeof next === 'number' && typeof previous === 'number' && next > previous) {
      setGemsAnimValue(1);
      const timer = setTimeout(() => setGemsAnimValue(0), 900);
      return () => clearTimeout(timer);
    }
  }, [userData?.net_score]);

  const [userIconAnimStyle, setUserIconAnimValue] = useAnimation({
    prop: 'borderColor',
    start: 'rgba(255, 255, 255, 0)',
    end: CCColors.Primary.Brown,
    isColor: true,
  });

  // Expiry status animations - using simpler manual approach
  const [isWarningBlinking, setIsWarningBlinking] = useState(false);
  const [isWarningBouncing, setIsWarningBouncing] = useState(false);

  // Handle urgent blinking animation - continuous
  useEffect(() => {
    let blinkInterval: NodeJS.Timeout;
    if (expiryStatus?.state === 'urgent') {
      setIsWarningBlinking(true);
      blinkInterval = setInterval(() => {
        setIsWarningBlinking(current => !current);
      }, 700); // Blink every 500ms for smoother transitions
    } else {
      setIsWarningBlinking(false);
    }

    return () => {
      if (blinkInterval) {
        clearInterval(blinkInterval);
      }
    };
  }, [expiryStatus?.state]);

  // Handle warning bouncing animation - continuous
  useEffect(() => {
    let bounceInterval: NodeJS.Timeout;
    if (expiryStatus?.state === 'warning') {
      setIsWarningBouncing(true);
      bounceInterval = setInterval(() => {
        setIsWarningBouncing(current => !current);
      }, 400); // Bounce every 600ms - alternating position
    } else {
      setIsWarningBouncing(false);
    }

    return () => {
      if (bounceInterval) {
        clearInterval(bounceInterval);
      }
    };
  }, [expiryStatus?.state]);

  // Helper function to get expiry status display info
  const getExpiryDisplayInfo = () => {
    if (!expiryStatus || expiryStatus.state === 'none') {
      return null;
    }

    const days = expiryStatus.days_to_expiry;
    let text = '';
    let backgroundColor = `${CCColors.Rewards.TextRed}16`;
    let textColor = CCColors.Rewards.TextRed;
    let transform = [{translateY: 0}];

    switch (expiryStatus.state) {
      case 'expired':
        text = 'Plan Expired';
        backgroundColor = CCColors.Red;
        textColor = CCColors.White;
        break;
      case 'warning':
        text = `Expiring in ${days} days`;
        backgroundColor = CCColors.Red;
        textColor = CCColors.White;
        transform = isWarningBouncing ? [{translateY: -8}] : [{translateY: 0}];
        // backgroundColor = isWarningBouncing ? '#ff4444' : CCColors.Red; // Test with color change
        break;
      case 'urgent':
        text = `Expiring in ${days} days`;
        backgroundColor = isWarningBlinking
          ? CCColors.Rewards.TextRed
          : `${CCColors.Rewards.TextRed}16`;
        textColor = isWarningBlinking
          ? CCColors.White
          : CCColors.Rewards.TextRed;
        break;
      case 'normal':
      default:
        text = `Expiring in ${days} days`;
        break;
    }

    return {
      text,
      backgroundColor,
      textColor,
      transform,
    };
  };

  const handleSwitchToProfile = async () => {
    await removeLocalStorage('user_key');
    await removeLocalStorage('profile_access');
    await removeLocalStorage('reports_user_id');
    setModifyMainMenu?.(false);
    setTimeout(() => {
      navigation.navigate(ScreenName.Dashboard);
    }, 10);
  };
  const [toRoute, setRoute] = useState<(() => void) | null>(null);
  const [rightSound] = useSound(successSound);
  const [notificationSound] = useSound(notificationSoundMp3);
  const [incorrectSound] = useSound(wrongSound);
  const [nextlevelSound] = useSound(levelupSound);
  const isThirdPartyUser = useLoggedInUserStore(
    state => state.isThirdPartyUser,
  );
  const [gems, pointsToNextLevel, level, netScore] = useLoggedInUserStore(
    useShallow(state => [
      state.gems,
      state.pointsToNextLevel,
      state.level,
      state.netScore,
    ]),
  );
  const [switchToDesktopBannerToggle, setSwitchToDesktopBannerToggle] =
    useState(true);
  useEffect(() => {
    const refreshHeader = async () => {
      const profile = await getLocalStorage('profile_access');
      setDuplicateTabHeaderName(profile);
    };
    refreshHeader();
  }, [modifyMainMenu]);
  useEffect(() => {
    if (activeStatusMessage) {
      setRoute(() => ROUTE_MAP[activeStatusMessage?.cta_details?.[0]?.action]);
      setIconDetails(ICON_MAP?.[activeStatusMessage?.icon] ?? {});
      setShowMyComponent(true);
    } else {
      setShowMyComponent(false);
    }
  }, [activeStatusMessage]);
  // const [ChallengeOpponent, setChallengeOpponent] = useState('');
  // const [showChallengeRequest, setShowChallengeRequest] = useState(false);
  // const [ChallengeMoveTimer, setChallengeMoveTimer] = useState(0);
  // const [ChallengeIncrement, setChallengeIncrement] = useState(0);
  // const [ChallengeVariantId, setChallengeVariantId] = useState(1);
  // const [ChallengePosition, setChallengePosition] = useState(
  //   'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
  // );
  // const [gamePlayMode, setGamePlayMode] = useState('Play');
  // const [ChallengeWhite, setChallengeWhite] = useState('');

  // const [showChallengeReject, setShowChallengeReject] = useState(false);
  // const [showChallengeExpire, setShowChallengeExpire] = useState(false);
  // const [showChallengeCancel, setShowChallengeCancel] = useState(false);

  // const handleChallengeResponse = async accepted => {
  //   let packet = {};
  //   packet.requestId = new Date().getTime().toString();
  //   packet.variantId = ChallengeVariantId;
  //   packet.userId = '' + userData.user_id;
  //   packet.opponent = ChallengeOpponent;
  //   packet.playerMoveTimer = ChallengeMoveTimer;
  //   packet.moveTimeIncrement = ChallengeIncrement;
  //   packet.gameState = ChallengePosition;
  //   packet.white = ChallengeWhite;
  //   packet.black = 'Black';
  //   packet.gamePlayMode = gamePlayMode;

  //   let timecontrol = '';

  //   if (accepted) {
  //     timecontrol =
  //       (ChallengeMoveTimer / 1000).toString() +
  //       ' + ' +
  //       (ChallengeIncrement / 1000).toString();

  //     packet.type = 'challenge_accept_response';
  //   } else {
  //     packet.type = 'challenge_reject';
  //   }
  //   console.log('Packet = ', packet);

  //   setShowChallengeRequest(false);

  //   await setLocalStorage('challengePacket', packet);

  //   navigation.navigate(ScreenName.PlayChess);
  // };

  useEffect(() => {
    const tempSwitchToDesktopBannerFunc = async () => {
      const tempSwitchToDesktopBanner = await getLocalStorage(
        'switchToDesktopBannerShow',
      );
      console.log(tempSwitchToDesktopBanner, 'tempSwitchToDesktopBanner');
      if (tempSwitchToDesktopBanner !== false) {
        setSwitchToDesktopBannerToggle(true);
      }
    };
    tempSwitchToDesktopBannerFunc();
  }, []);
  const ROUTE_MAP = getRouteMap(navigation);
  const handleStatusBarPress = () => {
    if (toRoute) {
      toRoute();
    } else if (activeStatusMessage?.cta_details?.[0]?.action === 'link') {
      window.open(activeStatusMessage?.cta_details?.[0]?.link, '_blank');
    } else {
      null;
    }
    // popupAction({
    //   popup_id: statusBanner?.id,
    //   mobile_number: userContact,
    //   cta_action: statusBanner?.ctaAction,
    // });
  };
  const handleSwitchToDesktopBannerClose = async () => {
    await setLocalStorage('switchToDesktopBannerShow', false);
    setSwitchToDesktopBannerToggle(false);
  };

  const hasNewNotifications = useNotificationStore(state =>
    state.hasNewNotifications(),
  );

  const latestInboxMessages = useNotificationStore(
    state => state.inboxMessages.filter(i => i.isNew),
    shallow,
  );

  const markInboxMessageSeen = useNotificationStore(
    state => state.markInboxMessageSeen,
  );

  const latestUserRaisedIssues = useNotificationStore(
    state => state.userRaisedIssue.filter(i => i.isNew),
    shallow,
  );
  const markUserRaisedIssueSeen = useNotificationStore(
    state => state.markUserRaisedIssueSeen,
  );

  const hasNewInboxMessages = useNotificationStore(state =>
    state.hasNewInboxMessages(),
  );
  const hasNewUserRaisedIssue = useNotificationStore(state =>
    state.hasNewUserRaisedIssue(),
  );
  const handleSwitchToAppBannerModal = () => {
    setShowAppModal(true);
  };
  useEffect(() => {
    if (hasNewNotifications || hasNewInboxMessages || hasNewUserRaisedIssue) {
      notificationSound();
    }
  }, [hasNewNotifications, hasNewInboxMessages, hasNewUserRaisedIssue]);

  const showToast = useToast();
  // Inbox toast: show attachment preview and who sent the message
  useEffect(() => {
    if (!latestInboxMessages?.length) return;
    console.log(latestInboxMessages, 'inbox messages');
    latestInboxMessages.forEach(msg => {
      const displayMessage =
        msg.body_format === 'html'
          ? lastMessagePreview(stripHtmlForPreview(msg.message))
          : lastMessagePreview(msg.message);
      const heading = msg.senderName?.trim()
        ? `Message from ${msg.senderName.trim()}`
        : 'Inbox Message';
      showToast(displayMessage, {
        onPress: () => {
          if (msg.clubId) {
            navigation.navigate(ScreenName.ClubRoom, {clubId: msg.clubId});
            return;
          }
          if (window.location.pathname.toLowerCase().includes('/classroom')) {
            const url = new URL(
              `${window.location.origin}/${ScreenName.Inbox}`,
            );
            url.searchParams.set('channelId', msg.requestId);
            window.open(url.toString(), '_blank');
            return;
          }
          navigation.navigate(ScreenName.Inbox, {
            channelId: msg.requestId, // or parse channelId if needed
          });
        },
        type: heading,
      });
      markInboxMessageSeen(msg.id);
    });
  }, [latestInboxMessages]);

  // Support issue toast
  useEffect(() => {
    if (!latestUserRaisedIssues?.length) return;
    console.log(latestUserRaisedIssues, 'issues');
    latestUserRaisedIssues.forEach(issue => {
      showToast(issue.message, {
        onPress: () => {
          if (window.location.pathname.toLowerCase().includes('/classroom')) {
            const url = new URL(
              `${window.location.origin}/${ScreenName.SupportTicket}`,
            );
            url.searchParams.set('ticketId', issue.id);
            window.open(url.toString(), '_blank');
            return;
          }
          navigation.navigate(ScreenName.SupportTicket, {
            ticketId: issue.id,
          });
        },
        type: 'Support Update',
      });
      markUserRaisedIssueSeen(issue.id);
    });
  }, [latestUserRaisedIssues]);

  return (
    <>
      {isMobileOrTab && switchToDesktopBannerToggle && (
        <SwitchToAppBanner
          handleSwitchToAppBannerClose={handleSwitchToAppBannerModal}
        />
      )}

      <View style={[styles.header, showMyComponent ? {} : styles.headerShadow]}>
        {/* <ChallengeComponent
          challenger={ChallengeOpponent}
          visible={showChallengeRequest}
          handleChallengeResponse={handleChallengeResponse}
          timeControl={
            (ChallengeMoveTimer / 60000).toString() +
            ' + ' +
            (ChallengeIncrement / 1000).toString()
          }
        /> */}

        <Box type="row-flex-start">
          <ConditionalRender
            condition={isMobile}
            childrenA={
              <Pressable style={styles.hamburgerIcon} onPress={toggleHamburger}>
                <Entypo name="menu" size={24} color={CCColors?.Primary.Brown} />
                {/* <OctiIcon name="three-bars" size={24} color="#fff" /> */}
              </Pressable>
            }
            childrenB={<></>}
          />
          <Box
            flexDirection={isMobileOrTab ? 'column' : 'row'}
            alignItems={'center'}>
            {isThirdPartyUser ? (
              <Spacer spacing={10} horizontal />
            ) : (
              <Pressable
                onPress={() => {
                  setModifyMainMenu?.(false);
                  if (
                    window.location.pathname
                      .toLowerCase()
                      .includes('/classroom')
                  ) {
                    const url = `${window.location.origin}/${ScreenName.Dashboard}`;
                    // const url = `${window.location.origin}/dashboard`;
                    window.open(url, '_blank');
                    return;
                  }
                  navigation.navigate(ScreenName.Dashboard);
                }}>
                {!isMobileOrTab ? (
                  <Image
                    resizeMode="contain"
                    style={[styles.logo, isMobileOrTab && styles.logoMobile]}
                    source={require('@/Assets/Images/Svgs/cc-logo-light.svg')}
                  />
                ) : (
                  <Box
                    style={{
                      flexDirection: 'row',
                      paddingBottom: 6,
                    }}>
                    <Image
                      style={styles.iconlogo}
                      source={require('@/Assets/Images/Svgs/ccIcon.svg')}
                    />
                    <Box
                      flexDirection="row"
                      alignItems="center"
                      justifyContent="center"
                      style={{paddingHorizontal: 6}}>
                      <CCText fontSize={14} color={CCColors.Primary.Dark}>
                        Circle
                      </CCText>
                      <CCText
                        fontWeight={600}
                        fontSize={14}
                        color={CCColors.Primary.Dark}>
                        Chess
                      </CCText>
                    </Box>
                  </Box>
                )}
              </Pressable>
            )}
            {/* <Box
              onPress={() => {
                navigation.navigate(ScreenName.Subscription);
              }}
              style={{
                backgroundColor: `${CCColors.Rewards.TextRed}16`,
                borderRadius: 4,
                marginRight: 10,
                marginBottom: isMobile && 5,
              }}>
              <CCText
                textAlign="center"
                color={CCColors.Rewards.TextRed}
                style={{padding: isMobile ? 2 : 10}}
                fontSize={isMobileOrTab ? 10 : 14}
                fontWeight="semibold">
                {userPlanStore?.activePlan === 'aspiringLearners'
                  ? 'Aspiring Learners'
                  : userPlanStore?.activePlan === 'aspiringChampions'
                  ? 'Aspiring Champions'
                  : `Novice Plan`}
              </CCText>
            </Box> */}

            {modifyMainMenu ? (
              <TouchableOpacity onPress={() => handleSwitchToProfile()}>
                <Box style={[styles.BackContainer]}>
                  <Ionicons name="arrow-back" size={18} />
                  {!isMobileOrTab && (
                    <>
                      <Spacer spacing={5} horizontal />
                      <CCText fontWeight="500" style={styles.backTextWrapper}>
                        Go Back
                      </CCText>
                    </>
                  )}
                </Box>
              </TouchableOpacity>
            ) : (
              (() => {
                const expiryInfo = getExpiryDisplayInfo();
                if (expiryInfo) {
                  return (
                    <Box
                      onPress={() => {
                        if (
                          window.location.pathname
                            .toLowerCase()
                            .includes('/classroom')
                        ) {
                          const url = `${window.location.origin}/${ScreenName.Renewal}`;
                          window.open(url, '_blank');
                          return;
                        }
                        navigation.navigate(ScreenName.Renewal);
                      }}
                      style={
                        {
                          backgroundColor: expiryInfo.backgroundColor,
                          borderRadius: 4,
                          width: isMobile && '93%',
                          transform: expiryInfo.transform,
                          ...(Platform.OS === 'web' && {
                            transition: 'all 0.6s ease-in-out',
                            willChange: 'transform, background-color',
                          }),
                        } as any
                      }>
                      <CCText
                        textAlign="center"
                        color={expiryInfo.textColor}
                        style={{
                          padding: isMobile ? 3 : 10,
                          ...(Platform.OS === 'web' && {
                            transition: 'color 0.6s ease-in-out',
                          }),
                        }}
                        fontSize={isMobileOrTab ? 10 : 14}
                        fontWeight="semibold">
                        {expiryInfo.text}
                      </CCText>
                    </Box>
                  );
                }
                return null;
              })()
            )}
            <PingIndicator />
          </Box>
        </Box>

        <View style={styles.headerRightItems}>
          {!isMobileOrTab && (
            <>
              {modifyMainMenu ? (
                <Box
                  style={{
                    backgroundColor: `${CCColors.Rewards.Pink}29`,
                    borderRadius: 4,
                  }}>
                  <CCText
                    textAlign="center"
                    color={CCColors.Rewards.Pink}
                    style={{padding: isMobile ? 3 : 10}}
                    fontSize={isMobileOrTab ? 10 : 14}
                    fontWeight="semibold">
                    In Coach Mode
                  </CCText>
                </Box>
              ) : (
                <UserAssistance />
              )}
            </>
          )}
          <Spacer spacing={15} horizontal />
          {gamePlayStore?.allowChallenge == false && (
            <Box
              onPress={async () => {
                gamePlayStore?.setAllowChallenge(true);
                await setLocalStorage('dnd-mode', 'everyone');
              }}
              style={[styles.BackContainer]}>
              <Foundation name="prohibited" size={18} color={'red'} />
              {!isMobileOrTab && (
                <>
                  <Spacer spacing={5} horizontal />
                  <CCText fontWeight="500" style={styles.backTextWrapper}>
                    DND Activated
                  </CCText>
                </>
              )}
            </Box>
          )}
          {/* Item 5: inline pill that surfaces an in-progress Fun
              Challenge battle when the user has navigated away from
              FunChallengeBattle. Renders null otherwise. */}
          <FunChallengeInProgressPill />
          {/* Raise a Ticket stays in the header for CSOC users and coaches
              only (support-heavy cohorts); everyone else has it in the
              profile dropdown. */}
          {showRaiseTicketCta && (
            <Box
              flexDirection="row"
              alignItems="center"
              gap={4}
              style={[
                styles.row,
                {
                  paddingHorizontal: isMobileOrTab ? 5 : 10,
                  paddingVertical: isMobileOrTab ? 5 : 7,
                  marginTop: isMobileOrTab ? 15 : 0,
                },
              ]}
              onPress={() => {
                setOpenModal(true);
              }}>
              <MaterialCommunityIcons
                color={CCColors.Primary.Brown}
                name="message-question-outline"
                size={16}
              />
              {!isMobileOrTab && (
                <CCText
                  style={{
                    marginBottom: 2,
                  }}
                  color={CCColors.Primary.Brown}
                  fontWeight={500}
                  fontSize={RFPercentage(1.1)}>
                  {RAISE_A_TICKET}
                </CCText>
              )}
            </Box>
          )}
          {showRaiseTicketCta && (
            <SupportModal openModal={openModal} handleClose={handleClose} />
          )}
          {/* Streak flame lives right-most (next to the profile), Duolingo-
              style, so its nudge bubble hangs off the header's right edge. */}
          {!isMobileOrTab && !modifyMainMenu && (
            <>
              <Spacer spacing={10} horizontal />
              <Streak />
            </>
          )}
          {isMobileOrTab && (
            <View style={styles.userDetails}>
              <Animated.View style={[styles.pointsPulseWrap, gemsAnimValue]}>
                <CCText showEllipses style={styles.userLevels}>
                  {userData?.net_score} points
                </CCText>
              </Animated.View>

              <Box style={{flexDirection: 'row', display: 'flex'}}>
                <Spacer spacing={5} horizontal />
                <Streak />
              </Box>
            </View>
          )}
          {menu(
            <Pressable
              onPress={() => userAccess({relation_type: 0})}
              onHoverIn={() => setUserIconAnimValue(1)}
              onHoverOut={() => setUserIconAnimValue(0)}>
              <Animated.View
                style={[isMobileOrTab ? styles.userMobile : styles.user]}>
                {!isMobileOrTab && (
                  <View style={styles.userDetails}>
                    <CCText showEllipses style={styles.userName}>
                      {!modifyMainMenu
                        ? userData.first_name || userData.last_name
                          ? `${userData.first_name} ${userData.last_name}`
                          : userData.username
                        : headerName || duplicateTabHeaderName}
                    </CCText>

                    {!modifyMainMenu && (
                      <Animated.View
                        style={[styles.pointsPulseWrap, gemsAnimValue]}>
                        <CCText showEllipses style={styles.userLevels}>
                          {userData?.net_score} points
                        </CCText>
                      </Animated.View>
                    )}
                  </View>
                )}

                <View style={{margin: 11}}>
                  <OnboardingRing
                    percent={onboardingPercent}
                    size={50}
                    ringWidth={3}
                    active={!onboardingComplete}>
                    <Animated.View
                      style={[
                        styles.userAvatarContainer,
                        userIconAnimStyle,
                        {margin: 0},
                      ]}>
                      <Icon
                        style={styles.userAvatar}
                        name={avatar?.avatarDP || 'chess-pawn'}
                        size={30}
                        color={Colors.primaryDark}
                      />
                      {(hasNewNotifications ||
                        hasNewInboxMessages != 0 ||
                        hasNewUserRaisedIssue != 0) && (
                        <View
                          style={{
                            width: 13,
                            height: 13,
                            borderRadius: 25,
                            backgroundColor: CCColors.Red,
                            position: 'absolute',
                            top: -3,
                            right: 2,
                          }}
                        />
                      )}
                    </Animated.View>
                  </OnboardingRing>
                </View>
              </Animated.View>
            </Pressable>,
            navigate,
            onLoginStateChange,
            userData,
            summaryData,
            setModifyMainMenu,
            userRelationData,
            modifyMainMenu,
            setHeaderName,
            isMobileOrTab,
            handleSwitchToProfile,
            userAccess,
          )}
        </View>
      </View>
      {showMyComponent && (
        <LinearGradient
          colors={[CCColors.Gradient.LightRed, CCColors.Gradient.DarkRed]} // Red for error
          start={{x: 0, y: 0}}
          end={{x: 1, y: 1}}
          style={[styles.extension, {overflow: 'hidden'}]}>
          {/* Shimmer overlay */}
          <Animated.View
            style={[
              StyleSheet.absoluteFillObject,
              shimmerStyle,
              {overflow: 'hidden'},
            ]}>
            <LinearGradient
              colors={[
                'transparent',
                'rgba(255,255,255,0.15)',
                'rgba(255,255,255,0.35)',
                'rgba(255,255,255,0.15)',
                'transparent',
              ]}
              start={{x: 0, y: 0}}
              end={{x: 1, y: 0}}
              style={[StyleSheet.absoluteFillObject]}
            />
          </Animated.View>
          <MeetingsBanner
            backgroundColor={null}
            iconName={iconDetails?.name}
            titleText={activeStatusMessage?.main_text}
            handlePress={handleStatusBarPress}
            isMobileOrTab={isMobileOrTab}
            fontSize={14}
            textColor={CCColors.White}
            subtitleText={activeStatusMessage?.sub_text || ''}
            customBtnStyle={{
              backgroundColor: CCColors.Primary.Default,
              paddingVertical: 3,
            }}
            iconDimension={20}
            color1="#eca52b"
            color2="#eca52b"
            iconColor={CCColors.White}
            borderColor={CCColors.White}
            closeIcon={activeStatusMessage?.close_icon ?? false}
            onClose={() => setShowMyComponent(false)}
            ctaText={activeStatusMessage?.cta_details?.[0]?.text}
            customPadding={vs(10)}
            customStyle={18}
          />
        </LinearGradient>
      )}
    </>
  );
  // }
}
